import { BaseScene } from '../../core/BaseScene.js';
import { PreloadScene } from './PreloadScene.js';

export class BootScene extends BaseScene {
  static readonly KEY = 'Boot';

  constructor() {
    super(BootScene.KEY);
  }

  create(): void {
    this.cameras.main.setBackgroundColor(0xfff3e9);
    this.scene.start(PreloadScene.KEY);
  }
}
